import { Box } from '@mui/material';
import React, { useEffect } from 'react';
import SideNav from './SideNav';
import { Outlet, useNavigate } from 'react-router-dom';
import Appbar from './Appbar';

//CSS
import './layout.css';
import '@utils/utilities.css';

const Main: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleStorage = (event: StorageEvent) => {
      if (
        event.key === 'refresh-consult-tabs' &&
        (globalThis.location.pathname === '/provider/consults' ||
          globalThis.location.pathname === '/provider/details')
      ) {
        navigate(0);
      }
    };

    globalThis.addEventListener('storage', handleStorage);

    return () => {
      globalThis.removeEventListener('storage', handleStorage);
    };
  }, []);

  return (
    <Box sx={{ display: 'flex', height: '100vh' }}>
      <Box
        component="nav"
        sx={{
          flexShrink: 0,
          height: '100vh',
          backgroundColor: 'background.paper',
        }}
      >
        <SideNav />
      </Box>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          // ml: 10,
          backgroundColor: 'background.default',
        }}
      >
        <Appbar />
        <Outlet />
      </Box>
    </Box>
  );
};
export default Main;
